import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteProgramFunction } from "../../services/programFunction";
import { toast } from "react-toastify";

const useDeleteProgramFunction = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: deleteProgramFunction,

        onSuccess: (status) => {
            if (status === 200) {
                queryClient.invalidateQueries({ queryKey: ["categories"] });
                toast.success("Program function deleted successfully");
            }
        },
        onError: (error: any) => {
            toast.error(error.response?.data?.message);
        }
    });
};

export default useDeleteProgramFunction;